import {GET, POST} from '../index'
// 登录
export const Login = (data) => {
  return POST('login', data)
}
// 自动登录
export const AutoLogin = (data) => {
  return POST('auto/login', data)
}
// 获取权限
export const Auth = (data) => {
  return GET('auth', data)
}



// WEBPACK FOOTER //
// ./src/api/login/index.js